<template>
  <div class="reponsiveSidebar" >

    <ul class="navbar-nav hide-scroll navbar-sidenav border-right margin-top py-3 px-2" id="exampleAccordion" >
      <li v-if="$can('crm_view')" class="nav-item mt-3">
        <a href="#crm" class="nav-link" :class="{ 'collapsed': showRoute != 'crm' }" data-toggle="collapse">
          <div class="d-flex justify-content-between align-items-center">
            <span class="nav-link-text font-weight-bold">CRM</span>
            <font-awesome-icon class="angle-collapse" icon="angle-right" />
          </div>
        </a>
        <ul class="sidenav-one-level collapse" :class="{ 'show': showRoute == 'crm' }" id="crm"
          data-parent="#exampleAccordion">
          <li  v-if="![0,1,3,5].includes(role) && [1,3,4].includes(selectedProduct)" class="nav-item" data-toggle="tooltip" data-placement="right" title="Dashboard">
            <router-link class="nav-link" to="/dashboard">
              <div class="d-flex justify-content-start align-items-center">
                <span class="fa fa-th fa-lg"></span>
                <span class="nav-link-text font-weight-bold pl-3">Dashboard</span>
              </div>
            </router-link>
          </li>
          <li v-if="$can('lead_list')" class="nav-item" data-toggle="tooltip"
            data-placement="right" title="Leads">
            <router-link class="nav-link" :to="'/demo-leads'">
              <div class="d-flex justify-content-start align-items-center">
                <span class="fa fa-bar-chart fa-lg"></span>
                <span class="nav-link-text font-weight-bold pl-3" v-on:click="setDefaultStatus">Leads</span>
              </div>
            </router-link>
          </li>
          <li  v-if="$can('onboarding_list') && selectedProduct == 1" class="nav-item"
          data-toggle="tooltip" data-placement="right" title="OnBoarding">
          <router-link class="nav-link" :to="'/on-boarding'">
            <div class="d-flex justify-content-start align-items-center">
              <span class="fa fa-handshake-o fa-lg d-block"></span>
              <span class="nav-link-text font-weight-bold pl-3">OnBoarding</span>
            </div>
          </router-link>
        </li>
        <li v-if="$can('organization_view') && selectedProduct == 1" class="nav-item" data-toggle="tooltip" data-placement="right"
          title="Organizations">
          <a class="nav-link nav-link-collapse collapsed" data-toggle="collapse" href="#organization-items-div">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M12.7317 5.92937C12.3924 6.16465 12.0096 6.32998 11.6056 6.41573C11.2017 6.50147 10.7847 6.50591 10.3791 6.42877C9.97342 6.35164 9.58718 6.19448 9.2429 5.96648C8.89863 5.73847 8.60322 5.44417 8.3739 5.10077C8.14459 4.75736 7.98596 4.37173 7.90729 3.96636C7.82861 3.56099 7.83146 3.14401 7.91567 2.73976C7.99988 2.33551 8.16376 1.95207 8.39775 1.61183C8.63173 1.2716 8.93114 0.981368 9.2785 0.758087C9.9643 0.305108 10.8015 0.142057 11.6072 0.304574C12.4129 0.467091 13.1214 0.941959 13.578 1.62537C14.0346 2.30879 14.202 3.14516 14.0437 3.95167C13.8854 4.75818 13.4143 5.46922 12.7333 5.92937H12.7317ZM11.8688 2.05168C11.6995 1.92987 11.5074 1.84338 11.3039 1.79735C11.1005 1.75132 10.8899 1.7467 10.6846 1.78376C10.4793 1.82081 10.2836 1.8988 10.1091 2.01306C9.9346 2.12733 9.78487 2.27553 9.66883 2.44886C9.55279 2.62219 9.47282 2.8171 9.43366 3.02198C9.39451 3.22686 9.39698 3.43752 9.44093 3.64142C9.48488 3.84533 9.56941 4.0383 9.68949 4.20886C9.80956 4.37942 9.96273 4.52408 10.1399 4.63421C10.4821 4.84211 10.8913 4.90995 11.2824 4.82361C11.6734 4.73726 12.016 4.50338 12.2388 4.1707C12.4617 3.83802 12.5476 3.43218 12.4787 3.03772C12.4097 2.64327 12.1913 2.29062 11.8688 2.05324V2.05168ZM15.9268 2.09833C16.3753 1.7967 16.9148 1.66087 17.4526 1.71422C17.9904 1.76757 18.4928 2.00677 18.8732 2.39063C19.1443 2.66389 19.3442 2.99948 19.4553 3.36798C19.5665 3.73649 19.5855 4.12664 19.5108 4.50421C19.436 4.88179 19.2698 5.23525 19.0266 5.53361C18.7834 5.83196 18.4708 6.06609 18.116 6.21545C17.69 6.39359 17.2204 6.44051 16.7676 6.35021C16.3147 6.25991 15.8991 6.0365 15.5739 5.70858C15.3295 5.46295 15.1425 5.16634 15.0261 4.83997C14.9098 4.51359 14.867 4.16554 14.9009 3.82071C14.9347 3.47588 15.0444 3.1428 15.2221 2.8453C15.3997 2.54781 15.6409 2.29327 15.9284 2.09988L15.9268 2.09833ZM16.6732 4.60156C16.8191 4.74692 17.0169 4.82834 17.2229 4.8279C17.3249 4.82768 17.4258 4.80738 17.52 4.76814C17.6141 4.72891 17.6996 4.67151 17.7716 4.59923C17.8436 4.52695 17.9006 4.4412 17.9395 4.34688C17.9783 4.25256 17.9982 4.15152 17.998 4.04951C17.9977 3.94751 17.9774 3.84655 17.9382 3.7524C17.899 3.65824 17.8416 3.57274 17.7693 3.50076C17.6245 3.35517 17.4288 3.27155 17.2236 3.26754C17.121 3.26733 17.0194 3.28745 16.9247 3.32674C16.83 3.36603 16.744 3.4237 16.6717 3.49642C16.5994 3.56915 16.5423 3.65548 16.5036 3.75043C16.4648 3.84538 16.4453 3.94707 16.4462 4.04961C16.4466 4.25667 16.5281 4.45533 16.6732 4.60312V4.60156ZM3.52573 18.0942H6.33992V19.6567H3.52573C3.03308 19.6523 2.56229 19.4527 2.21658 19.1017C1.86954 18.7494 1.67516 18.2746 1.67551 17.7801V14.9659C1.46617 14.9589 1.26043 14.9095 1.0707 14.8208C0.880967 14.7321 0.711183 14.6059 0.571596 14.4497C0.423274 14.2995 0.30687 14.1208 0.229383 13.9244C0.151897 13.728 0.114929 13.518 0.120703 13.3069V9.91433C0.125367 9.18046 0.416116 8.47925 0.929201 7.95839C1.44073 7.44375 2.13262 7.14989 2.85716 7.14522H5.718C5.33211 7.60478 5.04143 8.13646 4.86286 8.70936H2.85716C2.5416 8.7184 2.24135 8.8474 2.01756 9.07007C1.79775 9.29608 1.675 9.59906 1.67551 9.91433V13.3847H3.23031V17.7785C3.22671 17.8209 3.23174 17.8635 3.2451 17.9039C3.25846 17.9443 3.27988 17.9815 3.30805 18.0133C3.37055 18.0616 3.44677 18.0888 3.52573 18.091V18.0942ZM14.8758 7.95994C14.6214 7.70306 14.3187 7.49898 13.9852 7.35943C13.6517 7.21988 13.2938 7.14761 12.9323 7.14678H9.07638C8.35155 7.15258 7.65846 7.4449 7.14842 7.95994C6.63533 8.4808 6.34459 9.18202 6.33992 9.91589V14.8571C6.33772 15.2813 6.49923 15.6901 6.79081 15.9983C6.93057 16.1542 7.1004 16.2803 7.29009 16.369C7.47978 16.4577 7.68544 16.5072 7.89473 16.5145V20.1263C7.89327 20.3728 7.9406 20.6172 8.034 20.8453C8.12739 21.0735 8.26501 21.2809 8.43891 21.4556C8.71877 21.7169 9.07171 21.8863 9.44953 21.9407H12.5591C12.9965 21.8833 13.3971 21.6663 13.6841 21.3314C13.9711 20.9964 14.1242 20.5672 14.1139 20.1263V16.5129C14.3233 16.5059 14.529 16.4566 14.7188 16.3679C14.9085 16.2791 15.0783 16.1529 15.2179 15.9967C15.3661 15.8467 15.4824 15.6683 15.5599 15.4722C15.6374 15.2761 15.6744 15.0663 15.6687 14.8555V9.91433C15.6698 9.18385 15.3852 8.4819 14.8758 7.95839V7.95994ZM14.1139 14.9332H12.5591V20.1263C12.5576 20.2082 12.5242 20.2864 12.4659 20.344C12.4393 20.3754 12.4058 20.4002 12.368 20.4163C12.3303 20.4325 12.2892 20.4397 12.2482 20.4373H9.74494C9.66369 20.4335 9.58678 20.3995 9.52926 20.342C9.47175 20.2845 9.43777 20.2075 9.43398 20.1263V14.9332H7.89473V9.91433C7.89473 9.59871 8.01756 9.29552 8.23678 9.07007C8.46057 8.8474 8.76081 8.7184 9.07638 8.70936H12.9323C13.1678 8.71351 13.397 8.78635 13.5917 8.91892C13.7865 9.0515 13.9382 9.23805 14.0284 9.45566C14.0876 9.60121 14.1167 9.75724 14.1139 9.91433V14.9332ZM18.4829 19.6552H15.6687V18.0926H18.4674C18.5464 18.0904 18.6226 18.0632 18.6851 18.0149C18.7164 17.9843 18.7409 17.9474 18.757 17.9067C18.773 17.8659 18.7803 17.8223 18.7784 17.7785V13.3847H20.3332V9.91433C20.3337 9.59906 20.2109 9.29608 19.9911 9.07007C19.7673 8.8474 19.4671 8.7184 19.1515 8.70936H17.1458C16.9673 8.13643 16.6766 7.60473 16.2907 7.14522H19.1515C19.8762 7.15186 20.5689 7.44406 21.0795 7.95839C21.5926 8.47925 21.8833 9.18046 21.888 9.91433V13.3069C21.888 13.7314 21.7278 14.1387 21.4386 14.4466C21.1494 14.756 20.7545 14.941 20.3332 14.9643V17.7785C20.3332 18.2745 20.1388 18.7487 19.7921 19.1001C19.4464 19.4511 18.9756 19.6507 18.4829 19.6552ZM4.78512 1.70341C4.32245 1.70287 3.87016 1.84051 3.48623 2.09868C3.10229 2.35686 2.8042 2.7238 2.63016 3.15249C2.45451 3.58102 2.40891 4.05178 2.49905 4.50606C2.58919 4.96033 2.81107 5.37802 3.13702 5.70703C3.46286 6.03566 3.87926 6.2597 4.33304 6.35052C4.78682 6.44135 5.25737 6.39485 5.68459 6.21695C6.11181 6.03905 6.4763 5.73784 6.7315 5.35179C6.9867 4.96574 7.12103 4.51237 7.11732 4.04961C7.11732 3.42769 6.87166 2.83064 6.43321 2.39063C6.21731 2.17317 5.96057 2.0005 5.67774 1.88257C5.3949 1.76463 5.09155 1.70375 4.78512 1.70341ZM4.78512 4.83168C4.68258 4.83188 4.58101 4.81176 4.48629 4.77248C4.39157 4.73319 4.30558 4.67552 4.23329 4.60279C4.161 4.53007 4.10384 4.44373 4.06512 4.34878C4.0264 4.25383 4.00689 4.15215 4.00771 4.04961C4.00812 3.84312 4.09 3.64514 4.23558 3.49869C4.38115 3.35225 4.57864 3.26918 4.78512 3.26754C4.99097 3.27117 5.1873 3.35487 5.33245 3.50089C5.47759 3.64691 5.56012 3.84374 5.56252 4.04961C5.56212 4.2561 5.48023 4.45408 5.33466 4.60052C5.18909 4.74697 4.9916 4.83004 4.78512 4.83168Z"
                    fill="#9A9AB0" stroke="#9A9AB0" stroke-width="0.2" />
                </svg>
                <span class="nav-link-text font-weight-bold pl-2">Organizations</span>
              </div>
              <font-awesome-icon class="angle-collapse" icon="angle-right" />
            </div>
          </a>

          <ul class="sidenav-second-level collapse" id="organization-items-div">
            <!-- users links -->
             <!-- "v-if="role != 6" -->
            <li  v-if="$can('all_organization_list')" class="nav-item" data-toggle="tooltip" data-placement="right" title="All Organizations">
              <router-link class="nav-link" to="/organizations/all-organizations">
                <font-awesome-icon icon="cube" />
                <span class="nav-link-text pl-2 org">All Organizations</span>
              </router-link>
            </li>

            <li  v-if="$can('users_view')"  class="nav-item" data-toggle="tooltip" data-placement="right" title="Users">
              <a class="nav-link nav-link-collapse collapsed" data-toggle="collapse" href="#collapseMulti">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <font-awesome-icon :icon="['far', 'user']" />
                    <span class="nav-link-text pl-2">Users</span>
                  </div>
                  <font-awesome-icon class="angle-collapse" icon="angle-right" />
                </div>
              </a>
              <ul class="sidenav-third-level collapse" id="collapseMulti">
                <!-- <li>
                <router-link to="/users/banned">Banned Users</router-link>
              </li> -->
                <li v-if="$can('all_users_list')" title="All Users">
                  <router-link to="/users" exact>All Users</router-link>
                </li>
                <li v-if="selectedProduct == 1" title="Master User">
                  <router-link to="/users/master" exact>Master Users</router-link>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li v-if="$can('notifications_view')  && selectedProduct == 1" class="nav-item" data-toggle="tooltip"
          data-placement="right" title="Notifications">
          <a class="nav-link nav-link-collapse collapsed" data-toggle="collapse" href="#blog-notifications-div">
            <!-- <font-awesome-icon  :icon="['far', 'clone']" class="mr-3 fa-lg" /> -->
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M20.56 14.0193L18.5241 11.9834V9.28653C18.5218 7.42279 17.8285 5.6261 16.5782 4.2439C15.328 2.8617 13.6097 1.99218 11.7555 1.80346V0.261719H10.2514V1.80346C8.39721 1.99218 6.67887 2.8617 5.42864 4.2439C4.17841 5.6261 3.4851 7.42279 3.48277 9.28653V11.9834L1.44692 14.0193C1.30587 14.1603 1.22661 14.3516 1.22656 14.551V16.8072C1.22656 17.0067 1.3058 17.198 1.44684 17.339C1.58788 17.48 1.77917 17.5593 1.97863 17.5593H7.24311V18.1436C7.22675 19.0977 7.56304 20.0243 8.18754 20.7458C8.81204 21.4673 9.68083 21.933 10.6274 22.0536C11.1502 22.1055 11.6781 22.0473 12.1771 21.8829C12.6761 21.7185 13.1352 21.4515 13.5248 21.099C13.9144 20.7465 14.2259 20.3164 14.4393 19.8363C14.6527 19.3562 14.7632 18.8367 14.7638 18.3113V17.5593H20.0283C20.2277 17.5593 20.419 17.48 20.5601 17.339C20.7011 17.198 20.7803 17.0067 20.7803 16.8072V14.551C20.7803 14.3516 20.701 14.1603 20.56 14.0193ZM13.2596 18.3113C13.2596 18.9097 13.0219 19.4836 12.5988 19.9067C12.1757 20.3298 11.6018 20.5676 11.0034 20.5676C10.4051 20.5676 9.83119 20.3298 9.40807 19.9067C8.98495 19.4836 8.74724 18.9097 8.74724 18.3113V17.5593H13.2596V18.3113ZM19.2762 16.0551H2.7307V14.8624L4.76655 12.8265C4.9076 12.6855 4.98686 12.4943 4.9869 12.2948V9.28653C4.9869 7.69085 5.62079 6.16052 6.74911 5.0322C7.87743 3.90387 9.40776 3.26999 11.0034 3.26999C12.5991 3.26999 14.1295 3.90387 15.2578 5.0322C16.3861 6.16052 17.02 7.69085 17.02 9.28653V12.2948C17.02 12.4943 17.0993 12.6855 17.2403 12.8265L19.2762 14.8624V16.0551Z"
                    fill="#9A9AB0" stroke="#9A9AB0" stroke-width="0.5" />
                </svg>
                <span class="nav-link-text font-weight-bold pl-2">Notifications</span>
              </div>
              <font-awesome-icon class="angle-collapse" icon="angle-right" />
            </div>
          </a>

          <!-- notifications link -->
          <ul class="sidenav-second-level collapse" id="blog-notifications-div">
            <li v-if="$can('send_new_list')" class="nav-item" data-toggle="tooltip" data-placement="right" title="Send New">
              <router-link class="nav-link" to="/notifications/new">
                <div class="d-flex justify-content-start align-items-center">
                  <font-awesome-icon icon="cube" />
                  <span class="nav-link-text pl-2">Send New</span>
                </div>
              </router-link>
            </li>

            <li  v-if="$can('all_notifications_list')" class="nav-item" data-toggle="tooltip" data-placement="right" title="All Notifications">
              <router-link class="nav-link" to="/notifications">
                <div class="d-flex justify-content-start align-items-center">
                  <font-awesome-icon :icon="['far', 'clone']" />
                  <span class="nav-link-text pl-2">All Notifications</span>
                </div>
              </router-link>
            </li>
          </ul>
        </li>
          <li  v-if="$can('support_view') && selectedProduct == 1" class="nav-item" data-toggle="tooltip"
          data-placement="right" title="Support">
          <a class="nav-link nav-link-collapse collapsed" data-toggle="collapse" href="#blog-support-div">
            <div class="d-flex justify-content-between">
              <div>
                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11.2941 0.94043C5.23713 0.94043 0.321289 5.85627 0.321289 11.9133C0.321289 17.9703 5.23713 22.8861 11.2941 22.8861C17.3512 22.8861 22.267 17.9703 22.267 11.9133C22.267 5.85627 17.3512 0.94043 11.2941 0.94043ZM19.4799 8.7531L16.4294 10.015C16.1546 9.27554 15.723 8.60435 15.1642 8.04748C14.6055 7.49062 13.9328 7.06129 13.1924 6.78896L14.4543 3.73851C16.7586 4.61633 18.5911 6.4488 19.4799 8.7531ZM11.2941 15.2051C9.47265 15.2051 8.00228 13.7348 8.00228 11.9133C8.00228 10.0918 9.47265 8.62142 11.2941 8.62142C13.1156 8.62142 14.586 10.0918 14.586 11.9133C14.586 13.7348 13.1156 15.2051 11.2941 15.2051ZM8.14493 3.72753L9.42875 6.77799C8.67966 7.05098 7.99905 7.48396 7.43434 8.04678C6.86962 8.6096 6.43435 9.28874 6.15885 10.0369L3.10839 8.76407C3.54839 7.61867 4.22408 6.57847 5.09171 5.71085C5.95933 4.84322 6.99953 4.16753 8.14493 3.72753ZM3.10839 15.0625L6.15885 13.8006C6.43244 14.5468 6.8659 15.2242 7.42885 15.7853C7.99181 16.3463 8.67064 16.7775 9.41778 17.0486L8.13396 20.099C6.991 19.657 5.95331 18.9805 5.08773 18.113C4.22216 17.2456 3.5479 16.2064 3.10839 15.0625ZM14.4543 20.099L13.1924 17.0486C13.9363 16.773 14.6111 16.3387 15.1701 15.7759C15.7292 15.2131 16.1589 14.5353 16.4294 13.7896L19.4799 15.0735C19.0384 16.215 18.3634 17.2517 17.4979 18.1171C16.6325 18.9825 15.5958 19.6576 14.4543 20.099Z"
                    fill="#9A9AB0" />
                </svg>
                <span class="nav-link-text font-weight-bold pl-2">Support <span
                    class="badge badge-info unread_tickets_count"></span></span>
              </div>
              <font-awesome-icon class="angle-collapse" icon="angle-right" />
            </div>
          </a>

          <!-- Support link -->
          <ul class="sidenav-second-level collapse" id="blog-support-div">
            <li  v-if="$can('all_tickets_list')" class="nav-item" data-toggle="tooltip" data-placement="right" title="All Tickets">
              <router-link class="nav-link" to="/support">
                <font-awesome-icon :icon="['far', 'clone']" />
                <span class="nav-link-text pl-2">All Tickets</span>
              </router-link>
            </li>
          </ul>
        </li>
          <li  v-if="selectedProduct == 1" class="nav-item" data-toggle="tooltip"
               data-placement="right" title="Quick Task">
            <a class="nav-link nav-link-collapse collapsed" data-toggle="collapse" href="#quick-task">
              <div class="d-flex justify-content-between">
                <div>
                  <span class="fa fa-tasks fa-lg" aria-hidden="true"></span>
                  <span class="nav-link-text font-weight-bold pl-3">Quick Task</span>
                </div>
                <font-awesome-icon class="angle-collapse" icon="angle-right" />
              </div>
            </a>

            <!-- Support link -->
            <ul class="sidenav-second-level collapse" id="quick-task">
              <li  v-if="$can('all_tickets_list')" class="nav-item" data-toggle="tooltip" data-placement="right" title="My Tasks">
                <router-link class="nav-link" to="/quick-task/my-task">
                  <font-awesome-icon :icon="['far', 'clone']" />
                  <span class="nav-link-text pl-2">My Tasks</span>
                </router-link>
              </li>
              <li  v-if="$can('all_tickets_list')" class="nav-item" data-toggle="tooltip" data-placement="right" title="Assigned Tasks">
                <router-link class="nav-link" to="/quick-task/assigned-task">
                  <font-awesome-icon :icon="['far', 'clone']" />
                  <span class="nav-link-text pl-2">Assigned Tasks</span>
                </router-link>
              </li>
            </ul>
          </li>




        </ul>
      </li>
      <li v-if="$can('cms_view')" class="nav-item mt-3">
        <a href="#cms" class="nav-link collapsed" data-toggle="collapse">
          <div class="d-flex justify-content-between align-items-center">
            <span class="nav-link-text font-weight-bold">CMS</span>
            <font-awesome-icon class="angle-collapse" icon="angle-right" />
          </div>
        </a>
        <ul class="sidenav-one-level collapse" id="cms" data-parent="#exampleAccordion">
          <li v-if="![0,1].includes(role) " class="nav-item" data-toggle="tooltip" data-placement="right" title="Dashboard">
            <router-link class="nav-link" to="/dashboard">
              <div class="d-flex justify-content-start align-items-center">
                <span class="fa fa-th fa-lg"></span>
                <span class="nav-link-text font-weight-bold pl-3">Dashboard</span>
              </div>
            </router-link>
          </li>
          <li v-if="$can('media_list') && selectedProduct == 1 " class="nav-item"
          data-toggle="tooltip" data-placement="right" title="Media">
          <router-link class="nav-link" to="/media">
            <div class="d-flex justify-content-start align-items-center">
              <span class="fa fa-picture-o fa-lg" aria-hidden="true"></span>
              <span class="nav-link-text font-weight-bold pl-3">Media</span>
            </div>
          </router-link>
        </li>
        <li v-if="$can('blog_view')" class="nav-item" data-toggle="tooltip"
            data-placement="right" title="Blog">
            <a class="nav-link nav-link-collapse collapsed" data-toggle="collapse" href="#blog-items-div">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <i class="fas fa-pen-nib"></i>
                  <span class="nav-link-text font-weight-bold pl-4">Blog</span>
                </div>
                <font-awesome-icon class="angle-collapse" icon="angle-right" />
              </div>
            </a>

            <!-- categories link -->
            <ul class="sidenav-second-level collapse" id="blog-items-div">
              <!-- posts links -->
              <li v-if="$can('post_view')" class="nav-item" data-toggle="tooltip" data-placement="right"
                title="Post">
                <a class="nav-link nav-link-collapse collapsed" data-toggle="collapse" href="#post-btn">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <font-awesome-icon :icon="['far', 'clone']" />
                      <span class="nav-link-text">Post</span>
                    </div>
                    <font-awesome-icon class="angle-collapse" icon="angle-right" />
                  </div>
                </a>
                <ul class="sidenav-third-level collapse" id="post-btn">
                  <li  v-if="$can('categories_list')" class="nav-item" data-toggle="tooltip" data-placement="right" title="Categories">
                    <router-link class="nav-link" to="/categories">
                      <!-- <font-awesome-icon icon="cube" /> -->
                      <span class="nav-link-text">Categories</span>
                    </router-link>
                  </li>
                  <li v-if="$can('new_post_list')" title="New Post">
                    <router-link to="/posts/new-post">New Post</router-link>
                  </li>
                  <li v-if="$can('unpublished_post_list')" title="Unpublished Posts">
                    <router-link to="/posts/unpublished">Unpublished Posts</router-link>
                  </li>
                  <!-- <li>
                <router-link :to="'/users/' + userSlug + '/posts'">My Posts</router-link>
              </li> -->
                  <li v-if="$can('new_post_list')" title="All posts">
                    <router-link to="/posts" exact>All posts</router-link>
                  </li>
                </ul>
              </li>

              <!-- FAQ SECTION -->
              <li v-if="$can('faq_view') && selectedProduct == 1 " class="nav-item" data-toggle="tooltip" data-placement="right" title="FAQ">
                <a class="nav-link nav-link-collapse collapsed" data-toggle="collapse" href="#faq-btn">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <font-awesome-icon :icon="['far', 'clone']" />
                      <span class="nav-link-text">FAQ</span>
                    </div>
                    <font-awesome-icon class="angle-collapse" icon="angle-right" />
                  </div>
                </a>
                <ul class="sidenav-third-level collapse" id="faq-btn">
                  <li v-if="$can('categories_list') && selectedProduct == 1 " class="nav-item" data-toggle="tooltip" data-placement="right" title="Categories">
                    <router-link class="nav-link" to="/faqcategories">
                      <!-- <font-awesome-icon icon="cube" /> -->
                      <span class="nav-link-text">Categories</span>
                    </router-link>
                  </li>
                  <li v-if="$can('new_faq_list')  && selectedProduct == 1 " title="New FAQ">
                    <router-link to="/faqs/new-faq">New FAQ</router-link>
                  </li>
                  <!-- <li>
                <router-link :to="'/users/' + userSlug + '/posts'">My Posts</router-link>
              </li> -->
                  <li v-if="$can('all_faq_list')  && selectedProduct == 1" title="All FAQs">
                    <router-link to="/faqs" exact>All FAQs</router-link>
                  </li>
                </ul>
              </li>
              <!-- FAQ SECTION END -->

              <!-- comment link -->
              <li v-if="$can('latest_comments_list') && selectedProduct == 1 " class="nav-item" data-toggle="tooltip" data-placement="right"
                title="Latest Comments">
                <router-link to="/comments" class="nav-link">
                  <div class="d-flex justify-content-start align-items-center">
                    <font-awesome-icon icon="comments" />
                    <span class="nav-link-text">Latest Comments</span>
                  </div>
                </router-link>
              </li>
              <!-- comment link -->
              <li v-if="$can('tag_setting_list')  && selectedProduct == 1 " class="nav-item" data-toggle="tooltip" data-placement="right"
                title="Meta Tag Settings">
                <router-link to="/meta-tag-setting" class="nav-link">
                  <div class="d-flex justify-content-start align-items-center">
                    <font-awesome-icon icon="tag" />
                    <span class="nav-link-text">Meta Tag Settings</span>
                  </div>
                </router-link>
              </li>
            </ul>
        </li>

        <!--  -->
          <!--Case study section-->
           <!-- FAQ SECTION -->
           <li v-if="$can('case_study')" class="nav-item" data-toggle="tooltip" title="Case Study">
            <a class="nav-link nav-link-collapse collapsed" data-toggle="collapse" href="#casestudy-btn">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <font-awesome-icon :icon="['far', 'clone']" />
                  <span class="nav-link-text font-weight-bold pl-3">Case Study</span>
                </div>
                <font-awesome-icon class="angle-collapse" icon="angle-right" />
              </div>
            </a>
            
            <ul class="sidenav-third-level collapse" id="casestudy-btn">
              <li v-if="$can('new_case_study')" title="New Case Study">
               
                <router-link to="/case-study/create">
                  <div class="d-flex justify-content-start align-items-center">
                    <span class="nav-link-text"> New Case Study</span>
                  </div>
                </router-link>
              </li>
              <li v-if="$can('case_study')" title="Case Studies">
                <router-link to="/case-study" exact>
                  <div class="d-flex justify-content-start align-items-center">
                    <span class="nav-link-text">All Case Studies</span>
                  </div>
                </router-link>
              </li>
            </ul>
          </li>
          <!--Case study section end-->
           <!--Case user guide section-->
           <li v-if="$can('user_guide')" class="nav-item" data-toggle="tooltip" title="User Guide">
            <a class="nav-link nav-link-collapse collapsed" data-toggle="collapse" href="#userguide-btn">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <font-awesome-icon :icon="['far', 'clone']" />
                  <span class="nav-link-text font-weight-bold pl-3">User Guide</span>
                </div>
                <font-awesome-icon class="angle-collapse" icon="angle-right" />
              </div>
            </a>
            
            <ul class="sidenav-third-level collapse" id="userguide-btn">
              <li v-if="$can('user_guide')" title="New User Guide">
               
                <router-link to="/user-guide/create">
                  <div class="d-flex justify-content-start align-items-center">
                    <span class="nav-link-text"> New User Guide</span>
                  </div>
                </router-link>
              </li>
              <li v-if="$can('user_guide')" title="User Guides">
                <router-link to="/user-guide" exact>
                  <div class="d-flex justify-content-start align-items-center">
                    <span class="nav-link-text">All User Guides</span>
                  </div>
                </router-link>
              </li>
            </ul>
          </li>
          <!--user guide section end-->
             <!-- Event section-->
             <li v-if="$can('event')" class="nav-item" data-toggle="tooltip" title="Event">
              <a class="nav-link nav-link-collapse collapsed" data-toggle="collapse" href="#eventmod-btn">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <font-awesome-icon :icon="['far', 'clone']" />
                    <span class="nav-link-text font-weight-bold pl-3">Event</span>
                  </div>
                  <font-awesome-icon class="angle-collapse" icon="angle-right" />
                </div>
              </a>
              
              <ul class="sidenav-third-level collapse" id="eventmod-btn">
                <li v-if="$can('event')" title="New Event">
                 
                  <router-link to="/event/create">
                    <div class="d-flex justify-content-start align-items-center">
                      <span class="nav-link-text"> New Event</span>
                    </div>
                  </router-link>
                </li>
                <li v-if="$can('event')" title="Events">
                  <router-link to="/event" exact>
                    <div class="d-flex justify-content-start align-items-center">
                      <span class="nav-link-text">All Events</span>
                    </div>
                  </router-link>
                </li>
              </ul>
            </li>
            <!--event section end-->
               <!-- brochure section-->
               <li v-if="$can('brochure')" class="nav-item" data-toggle="tooltip" title="Brochure">
                <a class="nav-link nav-link-collapse collapsed" data-toggle="collapse" href="#brochure-btn">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <font-awesome-icon :icon="['far', 'clone']" />
                      <span class="nav-link-text font-weight-bold pl-3">Brochure</span>
                    </div>
                    <font-awesome-icon class="angle-collapse" icon="angle-right" />
                  </div>
                </a>
                
                <ul class="sidenav-third-level collapse" id="brochure-btn">
                  <li v-if="$can('brochure')" title="New Brochure">
                   
                    <router-link to="/brochure/create">
                      <div class="d-flex justify-content-start align-items-center">
                        <span class="nav-link-text"> New Brochure</span>
                      </div>
                    </router-link>
                  </li>
                  <li v-if="$can('brochure')" title="Brochures">
                    <router-link to="/brochure" exact>
                      <div class="d-flex justify-content-start align-items-center">
                        <span class="nav-link-text">All Brochures</span>
                      </div>
                    </router-link>
                  </li>
                </ul>
              </li>
              <!--brochure end-->
              <!-- webinar section-->
              <li v-if="$can('webinar')" class="nav-item" data-toggle="tooltip" title="Webinar">
                <a class="nav-link nav-link-collapse collapsed" data-toggle="collapse" href="#webinar-btn">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <font-awesome-icon :icon="['far', 'clone']" />
                      <span class="nav-link-text font-weight-bold pl-3">Webinar</span>
                    </div>
                    <font-awesome-icon class="angle-collapse" icon="angle-right" />
                  </div>
                </a>
                
                <ul class="sidenav-third-level collapse" id="webinar-btn">
                  <li v-if="$can('webinar')" title="New Webinar">
                   
                    <router-link to="/webinar/create">
                      <div class="d-flex justify-content-start align-items-center">
                        <span class="nav-link-text"> New Webinar</span>
                      </div>
                    </router-link>
                  </li>
                  <li v-if="$can('webinar')" title="Webinars">
                    <router-link to="/webinar" exact>
                      <div class="d-flex justify-content-start align-items-center">
                        <span class="nav-link-text">All Webinars</span>
                      </div>
                    </router-link>
                  </li>
                </ul>
              </li>
              <!--webinar section end-->
        </ul>
      </li>
      <li class="nav-item mt-3" v-if="$can('development_view') || $can('development_all')">
        <a href="#development" class="nav-link collapsed" data-toggle="collapse">
          <div class="d-flex justify-content-between align-items-center">
            <span class="nav-link-text font-weight-bold">Development</span>
            <font-awesome-icon class="angle-collapse" icon="angle-right" />
          </div>
        </a>
        <ul class="sidenav-one-level collapse" id="development" data-parent="#exampleAccordion">
         
          <li  v-if="$can('task_list') && [1,2,3,4].includes(selectedProduct)" class="nav-item"
          data-toggle="tooltip" data-placement="right" title="All Tasks">
          <router-link class="nav-link" to="/common/development/task">
            <div class="d-flex justify-content-start align-items-center">
              <span class="fa fa-tasks fa-lg" aria-hidden="true"></span>
              <span class="nav-link-text font-weight-bold pl-3">All Tasks</span>
            </div>
          </router-link>
        </li>
         <li v-for="item in sidebarItems" :key="item.id" v-if="$can(item.permission)  && [1,2,3,4].includes(selectedProduct)" class="nav-item"  data-toggle="tooltip" data-placement="right" :title="item.item">
            <router-link class="nav-link" :to="item.route">
                <div class="d-flex justify-content-start align-items-center">
                    <span :class="item.icon" aria-hidden="true"></span>
                    <span class="nav-link-text font-weight-bold pl-3">{{ item.item }}</span>
                </div>
            </router-link>
        </li>
          
         <li v-if="$can('view_delivery_calendar')  && [1,2,3,4].includes(selectedProduct)" class="nav-item"
          data-toggle="tooltip" data-placement="right" title="Delivery Calendar">
          <router-link class="nav-link" to="/development-tasks/schedular">
            <div class="d-flex justify-content-start align-items-center">
              <span class="fa fa-tasks fa-lg" aria-hidden="true"></span>
              <span class="nav-link-text font-weight-bold pl-3">Delivery Calendar</span>
            </div>
          </router-link>
        </li>
         <li v-if="$can('view_task_progress')" class="nav-item" data-toggle="tooltip" data-placement="right"
          title="Progress Report">
          <router-link class="nav-link" to="/progress-report">
            <div class="d-flex justify-content-start align-items-center">
              <span class="fas fa-users-cog fa-lg"></span>
              <span class="nav-link-text font-weight-bold pl-3">Progress Report</span>
            </div>
          </router-link>
        </li>
          <!-- <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Dashboard">
            <router-link class="nav-link" to="/dashboard">
              <div class="d-flex justify-content-start align-items-center">
                <span class="fa fa-th fa-lg"></span>
                <span class="nav-link-text font-weight-bold pl-3">Dashboard</span>
              </div>
            </router-link>
          </li>
          <li v-if="role == 0 || role == 1 || role == 2 || role == 6" class="nav-item" data-toggle="tooltip"
            data-placement="right" title="Leads">
            <router-link class="nav-link" :to="'/demo-leads'">
              <div class="d-flex justify-content-start align-items-center">
                <span class="fa fa-bar-chart fa-lg"></span>
                <span class="nav-link-text font-weight-bold pl-3" v-on:click="setDefaultStatus">Leads</span>
              </div>
            </router-link>
          </li> -->
        </ul>
      </li>
       <li v-if="$can('view_designer') && selectedProduct == 1" class="nav-item mt-3">
        <a href="#designer" class="nav-link collapsed" data-toggle="collapse">
          <div class="d-flex justify-content-between align-items-center">
            <span class="nav-link-text font-weight-bold">Designer</span>
            <font-awesome-icon class="angle-collapse" icon="angle-right" />
          </div>
        </a>
        <ul class="sidenav-one-level collapse" id="designer" data-parent="#exampleAccordion">

          <li  class="nav-item" v-if=" $can('designer_task_list')"
          data-toggle="tooltip" data-placement="right" title="All Tasks">
          <router-link class="nav-link" to="/common/designer/task">
            <div class="d-flex justify-content-start align-items-center">
              <span class="fa fa-tasks fa-lg" aria-hidden="true"></span>
              <span class="nav-link-text font-weight-bold pl-3">All Tasks</span>
            </div>
          </router-link>
         </li>
          <li  class="nav-item" v-if=" $can('designer_view_delivery_calendar')"
          data-toggle="tooltip" data-placement="right" title="Delivery Calendar">
          <router-link class="nav-link" to="/designer-tasks/designerschedular">
            <div class="d-flex justify-content-start align-items-center">
              <span class="fa fa-tasks fa-lg" aria-hidden="true"></span>
              <span class="nav-link-text font-weight-bold pl-3">Delivery Calendar</span>
            </div>
          </router-link>
        </li>
       </ul>
     </li>

      <li v-if="$can('admin_view')  && [1,3,4].includes(selectedProduct)" class="nav-item mt-3">
        <a href="#main-col" class="nav-link" :class="{ 'collapsed': showRoute != 'admin' }" data-toggle="collapse">
          <div class="d-flex justify-content-between align-items-center">
            <span class="nav-link-text font-weight-bold">Admin</span>
            <font-awesome-icon class="angle-collapse" icon="angle-right" />
          </div>
        </a>
        <ul class="sidenav-one-level collapse" :class="{ 'show': showRoute == 'admin' }" id="main-col"
        data-parent="#exampleAccordion">
        <li v-if="$can('dashboard_list') && [1,3,4].includes(selectedProduct)" class="nav-item" data-toggle="tooltip" data-placement="right" title="Dashboard">
          <router-link class="nav-link" to="/dashboard">
            <div class="d-flex justify-content-start align-items-center">
              <span class="fa fa-th fa-lg"></span>
              <span class="nav-link-text font-weight-bold pl-3">Dashboard</span>
            </div>
          </router-link>
        </li>

        <li v-if="$can('admin_users_list')  && selectedProduct == 1" class="nav-item" data-toggle="tooltip" data-placement="right"
          title="Admin Users">
          <router-link class="nav-link" to="/admin-users">
            <div class="d-flex justify-content-start align-items-center">
              <span class="fas fa-users-cog fa-lg"></span>
              <span class="nav-link-text font-weight-bold pl-3">Admin Users</span>
            </div>
          </router-link>
        </li>
        <!-- Login Logs -->
        <li v-if="$can('logs_view') && selectedProduct == 1" class="nav-item" data-toggle="tooltip"
          data-placement="right" title="Logs">
          <a class="nav-link nav-link-collapse collapsed" data-toggle="collapse" href="#logs-items-div">
            <!-- <font-awesome-icon  :icon="['far', 'clone']" class="mr-3 fa-lg" /> -->
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.2363 13.6436H22.6973V15.387H12.2363V13.6436Z" fill="#9A9AB0" />
                  <path d="M12.2363 17.1309H22.6973V18.8743H12.2363V17.1309Z" fill="#9A9AB0" />
                  <path d="M12.2363 20.6182H19.2103V22.3617H12.2363V20.6182Z" fill="#9A9AB0" />
                  <path
                    d="M17.4665 0.567383C16.6956 0.569676 15.9471 0.827666 15.3385 1.30093C14.7299 1.77419 14.2955 2.43598 14.1033 3.18262H7.00557V0.567383H0.0316117V7.54135H7.00557V4.92611H14.1033C14.1845 5.23813 14.3092 5.53717 14.4738 5.81442L5.27865 15.0096C4.74718 14.6893 4.13908 14.5186 3.51859 14.5153C2.86586 14.5129 2.22555 14.6937 1.67051 15.0372C1.11547 15.3807 0.667985 15.8731 0.378977 16.4584C0.089969 17.0436 -0.0289615 17.6983 0.0357174 18.3478C0.100396 18.9973 0.346088 19.6156 0.744837 20.1324C1.14359 20.6492 1.67938 21.0437 2.29126 21.271C2.90314 21.4983 3.56654 21.5493 4.20597 21.4182C4.8454 21.2871 5.4352 20.9791 5.90824 20.5293C6.38129 20.0796 6.7186 19.506 6.88179 18.874H10.4926V17.1305H6.88179C6.80059 16.8185 6.67587 16.5195 6.51129 16.2422L15.7065 7.04707C16.2379 7.36732 16.846 7.53809 17.4665 7.54135C18.3913 7.54135 19.2782 7.17397 19.9322 6.52003C20.5861 5.8661 20.9535 4.97917 20.9535 4.05436C20.9535 3.12956 20.5861 2.24263 19.9322 1.5887C19.2782 0.93476 18.3913 0.567383 17.4665 0.567383ZM5.26208 5.79785H1.7751V2.31087H5.26208V5.79785ZM3.51859 19.7458C3.17376 19.7458 2.83668 19.6435 2.54996 19.4519C2.26325 19.2604 2.03978 18.9881 1.90782 18.6695C1.77586 18.3509 1.74133 18.0004 1.8086 17.6622C1.87588 17.3239 2.04193 17.0133 2.28576 16.7695C2.52959 16.5256 2.84025 16.3596 3.17845 16.2923C3.51666 16.225 3.86722 16.2596 4.1858 16.3915C4.50438 16.5235 4.77668 16.7469 4.96825 17.0337C5.15983 17.3204 5.26208 17.6575 5.26208 18.0023C5.26162 18.4646 5.07779 18.9077 4.75092 19.2346C4.42405 19.5615 3.98085 19.7453 3.51859 19.7458ZM17.4665 5.79785C17.1217 5.79785 16.7846 5.6956 16.4979 5.50402C16.2112 5.31245 15.9877 5.04015 15.8557 4.72157C15.7238 4.40299 15.6893 4.05243 15.7565 3.71423C15.8238 3.37602 15.9899 3.06536 16.2337 2.82153C16.4775 2.5777 16.7882 2.41165 17.1264 2.34437C17.4646 2.2771 17.8151 2.31163 18.1337 2.44359C18.4523 2.57555 18.7246 2.79902 18.9162 3.08573C19.1078 3.37245 19.21 3.70953 19.21 4.05436C19.2095 4.51662 19.0257 4.95982 18.6988 5.28669C18.372 5.61356 17.9288 5.79739 17.4665 5.79785Z"
                    fill="#9A9AB0" />
                </svg>
                <span class="nav-link-text font-weight-bold pl-2">Logs</span>
              </div>
              <font-awesome-icon class="angle-collapse" icon="angle-right" />
            </div>
          </a>

          <ul class="sidenav-second-level collapse" id="logs-items-div">
            <!-- users links -->

            <!--          <li class="nav-item" data-toggle="tooltip" data-placement="right" title="All Organizations">-->
            <!--            <router-link class="nav-link" to="/organizations">-->
            <!--              <font-awesome-icon icon="cube" />-->
            <!--              <span class="nav-link-text font-weight-bold pl-2">All Organizations</span>-->
            <!--            </router-link>-->
            <!--          </li>-->

            <li v-if="$can('login_logs_view')" class="nav-item" data-toggle="tooltip" data-placement="right" title="Login Logs">
              <a class="nav-link nav-link-collapse collapsed" data-toggle="collapse" href="#collapseMulti">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <font-awesome-icon :icon="['far', 'user']" />
                    <span class="nav-link-text pl-2">Login Logs</span>
                  </div>
                  <font-awesome-icon class="angle-collapse" icon="angle-right" />
                </div>
              </a>
              <ul class="sidenav-third-level collapse" id="collapseMulti">
                <!-- <li>
                <router-link to="/users/banned">Banned Users</router-link>
              </li> -->
                <li v-if="$can('admin_users_log_list')" title="Admin Users Log">
                  <router-link to="/users/admin-log" exact>Admin Users Log</router-link>
                </li>
                <li>
                  <!-- <router-link to="/users/log" exact>Users Log</router-link> -->
                </li>
              </ul>
            </li>
          </ul>
          </li>
          <!-- settings link -->
          <li v-if="$can('term_condition_list') && selectedProduct == 1" class="nav-item" data-toggle="tooltip"
          data-placement="right" title="Term & Conditions">
          <router-link class="nav-link" to="/term&conditions">
            <!-- <font-awesome-icon   :icon="['far', 'clone']" class="mr-3 fa-lg" /> -->
            <div class="d-flex justify-content-between">
              <div>
                <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M1.01855 17.9952C1.01855 17.7535 1.1146 17.5216 1.28556 17.3506C1.45652 17.1797 1.68838 17.0836 1.93016 17.0836H14.6926C14.9344 17.0836 15.1662 17.1797 15.3372 17.3506C15.5081 17.5216 15.6042 17.7535 15.6042 17.9952C15.6042 18.237 15.5081 18.4689 15.3372 18.6398C15.1662 18.8108 14.9344 18.9068 14.6926 18.9068H1.93016C1.68838 18.9068 1.45652 18.8108 1.28556 18.6398C1.1146 18.4689 1.01855 18.237 1.01855 17.9952ZM1.01855 12.5256C1.01855 12.2839 1.1146 12.052 1.28556 11.881C1.45652 11.7101 1.68838 11.614 1.93016 11.614H21.9854C22.2272 11.614 22.459 11.7101 22.63 11.881C22.8009 12.052 22.897 12.2839 22.897 12.5256C22.897 12.7674 22.8009 12.9993 22.63 13.1702C22.459 13.3412 22.2272 13.4372 21.9854 13.4372H1.93016C1.68838 13.4372 1.45652 13.3412 1.28556 13.1702C1.1146 12.9993 1.01855 12.7674 1.01855 12.5256ZM1.01855 7.05602C1.01855 6.81424 1.1146 6.58237 1.28556 6.41142C1.45652 6.24046 1.68838 6.14441 1.93016 6.14441H21.9854C22.2272 6.14441 22.459 6.24046 22.63 6.41142C22.8009 6.58237 22.897 6.81424 22.897 7.05602C22.897 7.29779 22.8009 7.52966 22.63 7.70061C22.459 7.87157 22.2272 7.96762 21.9854 7.96762H1.93016C1.68838 7.96762 1.45652 7.87157 1.28556 7.70061C1.1146 7.52966 1.01855 7.29779 1.01855 7.05602ZM8.31137 1.58641C8.31137 1.34463 8.40741 1.11277 8.57837 0.941807C8.74933 0.770848 8.9812 0.674805 9.22297 0.674805H21.9854C22.2272 0.674805 22.459 0.770848 22.63 0.941807C22.8009 1.11277 22.897 1.34463 22.897 1.58641C22.897 1.82818 22.8009 2.06005 22.63 2.23101C22.459 2.40196 22.2272 2.49801 21.9854 2.49801H9.22297C8.9812 2.49801 8.74933 2.40196 8.57837 2.23101C8.40741 2.06005 8.31137 1.82818 8.31137 1.58641Z"
                    fill="#9A9AB0" stroke="#9A9AB0" stroke-width="0.5" />
                </svg>

                <span class="nav-link-text font-weight-bold pl-2">Term & Conditions</span>
              </div>
            </div>
          </router-link>
        </li>
        <li v-if="$can('contract_list') && selectedProduct == 1" class="nav-item" data-toggle="tooltip"
          data-placement="right" title="Contract">
          <router-link class="nav-link" to="/customer-contracts">
            <!-- <font-awesome-icon   :icon="['far', 'clone']" class="mr-3 fa-lg" /> -->
            <div class="d-flex justify-content-between">
              <div>
                <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M1.01855 17.9952C1.01855 17.7535 1.1146 17.5216 1.28556 17.3506C1.45652 17.1797 1.68838 17.0836 1.93016 17.0836H14.6926C14.9344 17.0836 15.1662 17.1797 15.3372 17.3506C15.5081 17.5216 15.6042 17.7535 15.6042 17.9952C15.6042 18.237 15.5081 18.4689 15.3372 18.6398C15.1662 18.8108 14.9344 18.9068 14.6926 18.9068H1.93016C1.68838 18.9068 1.45652 18.8108 1.28556 18.6398C1.1146 18.4689 1.01855 18.237 1.01855 17.9952ZM1.01855 12.5256C1.01855 12.2839 1.1146 12.052 1.28556 11.881C1.45652 11.7101 1.68838 11.614 1.93016 11.614H21.9854C22.2272 11.614 22.459 11.7101 22.63 11.881C22.8009 12.052 22.897 12.2839 22.897 12.5256C22.897 12.7674 22.8009 12.9993 22.63 13.1702C22.459 13.3412 22.2272 13.4372 21.9854 13.4372H1.93016C1.68838 13.4372 1.45652 13.3412 1.28556 13.1702C1.1146 12.9993 1.01855 12.7674 1.01855 12.5256ZM1.01855 7.05602C1.01855 6.81424 1.1146 6.58237 1.28556 6.41142C1.45652 6.24046 1.68838 6.14441 1.93016 6.14441H21.9854C22.2272 6.14441 22.459 6.24046 22.63 6.41142C22.8009 6.58237 22.897 6.81424 22.897 7.05602C22.897 7.29779 22.8009 7.52966 22.63 7.70061C22.459 7.87157 22.2272 7.96762 21.9854 7.96762H1.93016C1.68838 7.96762 1.45652 7.87157 1.28556 7.70061C1.1146 7.52966 1.01855 7.29779 1.01855 7.05602ZM8.31137 1.58641C8.31137 1.34463 8.40741 1.11277 8.57837 0.941807C8.74933 0.770848 8.9812 0.674805 9.22297 0.674805H21.9854C22.2272 0.674805 22.459 0.770848 22.63 0.941807C22.8009 1.11277 22.897 1.34463 22.897 1.58641C22.897 1.82818 22.8009 2.06005 22.63 2.23101C22.459 2.40196 22.2272 2.49801 21.9854 2.49801H9.22297C8.9812 2.49801 8.74933 2.40196 8.57837 2.23101C8.40741 2.06005 8.31137 1.82818 8.31137 1.58641Z"
                    fill="#9A9AB0" stroke="#9A9AB0" stroke-width="0.5" />
                </svg>

                <span class="nav-link-text font-weight-bold pl-2">Contract</span>
              </div>
            </div>
          </router-link>
        </li>
        <!-- <li v-if="[0,1].includes(role) && selectedProduct == 1" class="nav-item" data-toggle="tooltip"
          data-placement="right" title="Settings">
          <router-link class="nav-link" to="/settings">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <font-awesome-icon icon="wrench" class="fa-lg" />
                <span class="nav-link-text font-weight-bold pl-2">Settings</span>
              </div>
            </div>
          </router-link>
        </li> -->

        <li v-if="$can('setting_view') && selectedProduct == 1" class="nav-item" data-toggle="tooltip" data-placement="right" title="Settings">
          <a class="nav-link nav-link-collapse collapsed" data-toggle="collapse" href="#settingToggle">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <font-awesome-icon icon="wrench" class="fa-lg" />
                <span class="nav-link-text font-weight-bold pl-2">Settings</span>
              </div>
              <font-awesome-icon class="angle-collapse" icon="angle-right" />
            </div>
          </a>
          <ul class="sidenav-third-level collapse" id="settingToggle">
            <li v-if="$can('admin_portal_list')" title="Admin portal">
              <router-link class="nav-link" to="/settings">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <span class="nav-link-text pl-2">Admin portal</span>
                  </div>
                </div>
              </router-link>
            </li>
            <li v-if="$can('calendly_widget_list')" title="Calendly widget">
              <router-link class="nav-link" to="/calendly-widget-settings">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <span class="nav-link-text pl-2">Calendly widget</span>
                  </div>
                </div>
              </router-link>
            </li>
          </ul>
      </li>
        <!-- </li> -->

      </ul>
      </li>

      <!-- <li class="nav-item mt-3">
        <router-link class="nav-link" to="/customer-view">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <span class="nav-link-text pl-2">View</span>
            </div>
          </div>
        </router-link>
      </li> -->
    </ul>

    <!-- sidebar toggler btn -->
    <!-- <ul v-if="role == 0 || role == 1" class="navbar-nav sidenav-toggler">
      <li class="nav-item">
        <a class="nav-link text-center" id="sidenavToggler">
        </a>
      </li>
    </ul> -->
    <!-- /sidebar toggler btn -->
  </div>



</template>
<script>
  import { mapGetters,  mapActions } from 'vuex';
export default {
  data: function () {
    return {
      product: 0,
      userSlug: window.$user.slug,
      role: "",
    };
  },
  computed: {
    showRoute: function () {
      let crmRoute = ['/categories','/demo-leads', '/posts/new-post', '/posts', '/posts/unpublished','/posts/update-post/', '/faqcategories', '/comments', '/meta-tag-setting', '/faqs/new-faq', '/faqs','/support'];
      let route ="'"+JSON.stringify(crmRoute)+"'";
      if (crmRoute.indexOf(route) != -1) {
        return "crm";
      } else {
        return "admin"; 
      }
    },
     ...mapGetters('persist', ['taskTypesList']),
      sidebarItems() {
      return this.taskTypesList.map(type => ({
        id: type.id,
        permission: type.permission,
        route: type.route,
        icon: type.icon,
        item: type.item
      }));
    },

    selectedProduct: function () {
      return this.$store.getters["persist/selectedProduct"];
    },
  },

  created: function () {
    this.product = localStorage.getItem('product');
    this.$gate.setUnreadTicketsCount();
    this.role = JSON.parse(localStorage.getItem("role"));
     this.getAllType();
    

  },
  watch: {
    selectedProduct: function () {
      this.product = localStorage.getItem('product');
    },
  },

  methods: {
    ...mapActions('teams', ['getAllType']),
    setDefaultStatus() {
      localStorage.setItem("tab", "all");
      localStorage.setItem('software_filter', 'all');
    }
  }
};
</script>


<style scoped>
li .nav-link svg:hover {}

.org {
  position: absolute;
}
.sidenav-one-level > .nav-item> .nav-link:hover svg path {
    fill: white;
}
@media (min-width: 320px) and (max-width:680px) {
  #exampleAccordion {
    z-index: 1;
    background-color: white;
    padding: 0% 5%;
    width: 102% !important;
  }

  .sidenav-second-level {
    list-style-type: none !important;
  }

  .nav-link span {
    font-size: 0.8rem !important;
  }

  .nav-link-collapse svg {
    width: 19 !important;
    height: 20 !important;
  }

  #navbarResponsive {
    width: 110% !important;
  }

  .reponsiveSidebar {
    z-index: 10;
  }

  #exampleAccordion.border-right {
    border-bottom: 1px solid #00000000 !important;
  }

}
@media screen and (max-width:992px) and (min-width:319px){
  #mainNav.navbar-dark .navbar-collapse .navbar-sidenav .nav-item > .nav-link .nav-link-text, 
  #mainNav .navbar-collapse .navbar-sidenav > .nav-item > .nav-link.collapsed .angle-collapse{
    color: #9A9AB0;
    font-size: 12px;
  }
  #mainNav.navbar-dark .navbar-collapse .navbar-sidenav .nav-item > .nav-link .fa-lg,
  #mainNav.navbar-dark .navbar-collapse .navbar-sidenav .nav-item > .nav-link svg{
    font-size: 0.7em;
    width: 16px;
  }
  #mainNav .navbar-collapse .navbar-sidenav > .nav-item > .nav-link{
    background: rgba(72, 166, 166, 0.1803921569) !important;
  }
  #mainNav .navbar-collapse .navbar-sidenav .sidenav-one-level > li > a.nav-link{
    padding:5px 10px;
  }
  #mainNav .navbar-collapse .navbar-sidenav .sidenav-one-level > li > a.nav-link:hover .nav-link-text{
    color:#fff !important;
  }
}
</style>